import React, { Fragment, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { withRouter, withRouterMatch } from 'hocs';

import { orderSingleFetch } from 'store/orderSingle/actions';
import { ordersFindFetchIfNeeded } from 'store/ordersFind/actions';

import {
  ordersDetailsFetchIfNeeded,
  ordersSetViewedFetchIfNeeded,
  ordersFilesFetchIfNeeded,
  ordersSetFavoriteFetch,
  ordersSetStatusReservedFetch,
  ordersSetStatusRejectedFetch,
  ordersSetStatusAcceptedFetch,
  ordersSetStatusRejectedAcceptedFetch,
  ordersSetStatusRevisionCompletedFetch,
  ordersMessagesFetch,
  ordersMessagesSetReadFetch,
  ordersMessagesAddFetch,
  orderFileUploadFetch,
  orderFilesUploadFetch,
  ordersMessagesAddAttachFetch,
  ordersMessagesAddConfirmFetch,
  ordersMessagesDeleteConfirmFetch,
  ordersFilesRemoveFetch,
  ordersSetStatusJoinChatFetch,
  ordersSetStatusRejectJoinChatFetch,
} from 'store/orders/actions';


import { getTakenOrderNotifications } from 'store/ordersNotifications/selectors';

import { closeModalComponent } from 'store/modals/actions';

import utils from 'utils';
import { getStatus } from 'components/order/utils';

import Order from 'components/order/Order';
import { CalcHeightContext } from 'components/order/CalcHeightContext';

import CommonFooter from 'components/CommonFooter';
import { OrderNaModal } from 'components/order/modals';

import { toastConfig } from 'constants';

const mapStateToPropsOrder = (state, ownProps) => {
  const { orderNumber } = ownProps;
  const { user } = state;
  let order = state.orders[orderNumber] || {};
  const isTaken = getTakenOrderNotifications(state).includes(orderNumber);
  if (ownProps.showAdditionalInfo) {
    order = utils.checkOrderTags(state.orders[orderNumber], user, state.settings.orderSubjectGroups);
  }
  const error = order.error || null;
  const isFilesLoading = !order.files || order.files.isFetching || order.files.didInvalidate;
  const isMessagesLoading = !order.messages || order.messages.isFetching || order.messages.didInvalidate;
  const isLoading = order.isFetching || order.didInvalidate || isFilesLoading || isMessagesLoading;
  const fileItems = !order.files || !order.files.items ? {} : order.files.items;
  const fileWebhook = !order.files || !order.files.webhook ? '' : order.files.webhook;
  const messageList = !order.messages || !order.messages.items ? [] : Object.values(order.messages.items);
  const isLoadingAdd = !order.messages ? true : order.messages.isFetchingAdd;
  const isStatusLoading = order.isFetchingStatus || false;
  const hasClientChatNotification = Boolean((state.clientChatNotifications.notifications.find(it => it.node === order.jabber_node) || {}).count) || false;
  return {
    isLoading, order, error, fileItems, fileWebhook, isStatusLoading, messageList, isLoadingAdd, user, isTaken, hasClientChatNotification,
  };
};

const mapDispatchToPropsOrder = (dispatch, ownProps) => {
  const { orderNumber, onSelect } = ownProps;

  return {
    loadDetails: () => new Promise((resolve, reject) => {
      try {
        dispatch(ordersDetailsFetchIfNeeded(orderNumber)).then(async (json = {}) => {
          if (json.noFetch) {
            resolve();
            return;
          }

          if (!json.details) {
            onSelect();
            resolve();
            return;
          }

          const { details: { _id: orderId } } = json;
          await dispatch(ordersSetViewedFetchIfNeeded(orderNumber, orderId));
          await dispatch(ordersFilesFetchIfNeeded(orderNumber, orderId));
          await dispatch(ordersMessagesFetch(orderNumber, orderId));
          resolve();
        });
      } catch (e) {
        console.error(e);
        reject();
      }
    }),
    orderSetViewed: orderId => dispatch(ordersSetViewedFetchIfNeeded(orderNumber, orderId)),
    setFavorite: value => dispatch(ordersSetFavoriteFetch(orderNumber, value)),
    setReserved: () => dispatch(ordersSetStatusReservedFetch(orderNumber)),
    setRejected: () => dispatch(ordersSetStatusRejectedFetch(orderNumber)),
    setAccepted: () => dispatch(ordersSetStatusAcceptedFetch(orderNumber)),
    setRejectAccepted: payload => dispatch(ordersSetStatusRejectedAcceptedFetch(orderNumber, payload)),
    setRevisionCompleted: payload => dispatch(ordersSetStatusRevisionCompletedFetch(orderNumber, payload)),
    setMessageRead: (messageId, message) => dispatch(ordersMessagesSetReadFetch(orderNumber, messageId, message)),
    addMessage: (to, message) => dispatch(ordersMessagesAddFetch(orderNumber, to, message)),
    uploadFile: (file, group) => dispatch(orderFileUploadFetch(orderNumber, file, group, null, ['final'])),
    uploadOrderFiles: (files = [], group) => dispatch(orderFilesUploadFetch(orderNumber, files, group, ['final'])),
    addMessageAttach: (to, files, message) => dispatch(ordersMessagesAddAttachFetch(orderNumber, to, files, message)),
    addMessageConfirm: (to, message, files) => dispatch(ordersMessagesAddConfirmFetch(orderNumber, to, message, files)),
    deleteMessageConfirm: (number, message) => dispatch(ordersMessagesDeleteConfirmFetch(number, message)),
    removeFile: fileId => dispatch(ordersFilesRemoveFetch(orderNumber, fileId)),
    closeModalComponentHandler: component => dispatch(closeModalComponent(component)),
    setJoinChat: () => dispatch(ordersSetStatusJoinChatFetch(orderNumber)),
    setRejectJoinChat: payload => dispatch(ordersSetStatusRejectJoinChatFetch(orderNumber, payload)),
  };
};

const OrderStandalone = connect(mapStateToPropsOrder, mapDispatchToPropsOrder)(Order);

const OrderStandalonePage = ({
  loadOrders, history, isLoading, mobile = false, number, currentOrder, error,
  location,
}) => {
  const { standAloneContainerHeight } = useContext(CalcHeightContext);
  let showAdditionalInfo = false;

  const renderOrder = () => {
    if (error) {
      return (<OrderNaModal onClose={() => { history.replace('/'); }} />);
    }
    if (!number) {
      return null;
    }
    if (mobile && utils.isNTorder(currentOrder)) {
      return (
        <div className="row minWidth100 center_center half-height fs15">
          <strong>Now we have only desktop version for this page</strong>
        </div>
      );
    }
    return (
      <Fragment>
        <OrderStandalone
          showAdditionalInfo={showAdditionalInfo}
          standalone
          orderNumber={number}
          mobile={mobile}
          onSelect={() => { history.replace('/'); }}
        />
        <ToastContainer {...toastConfig} />
      </Fragment>
    );
  };

  useEffect(() => {
    const searchParams = location.search.split('?')[1];
    const params = searchParams && searchParams.split('&');
    showAdditionalInfo = params && params.find(param => param.indexOf('show_additional') > -1 && param.indexOf('true') > -1);
    loadOrders();
    if (location.search) {
      history.replace(history.pathname);
    }
  }, []);

  return (
    <div className="order-standalone-page single-page" style={{ height: standAloneContainerHeight }}>
      <a href="/" className="logo" />
      <section className="container single-page-container">
        {isLoading
            ? <div className="preloading"><p>Loading</p></div>
            : renderOrder()
          }
      </section>
      {!mobile && <CommonFooter renderAnyWay />}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { number } = state.orderSingle;
  const isLoading = state.orderSingle.isFetching || state.ordersFind.isFetching;
  const { error } = state.orderSingle;
  const currentOrder = (state.orders || {})[number];
  return {
    isLoading, number, error, currentOrder,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  loadOrders: () => {
    dispatch(ordersFindFetchIfNeeded()).then(() => {
      dispatch(orderSingleFetch(ownProps.match.params.id)).then((json) => {
        const { number, _id: orderId } = json;
        dispatch(ordersSetViewedFetchIfNeeded(number, orderId));
        dispatch(ordersFilesFetchIfNeeded(number, orderId));
        dispatch(ordersMessagesFetch(number, orderId));
      });
    });
  },
});

export default withRouterMatch(withRouter(connect(mapStateToProps, mapDispatchToProps)(OrderStandalonePage)));
